import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue";
import { Effect, PaginationType } from "@/types";
import MainCard from "@/components/main/MainCard.vue";
import SwiperCore, { EffectCoverflow, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.scss";
import { IFavoriteLine } from "@/domain/entities/favoriteLine";
import { IBusStop } from "@/domain/entities/busStop";
import { IOnBoardLine } from "@/domain/entities/onBoardLine";


const __default__ = {
  name: "CardSwiper",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  navigation: {
    type: Boolean,
    default: false,
  },
  favoriteLines: {
    type: Array as PropType<Array<IFavoriteLine>>,
    required: true,
  },
  shouldCurrentCardShowFront: {
    type: Boolean,
    default: true,
  },
  updateKey: {
    type: Number,
  },
  onBoardLine: {
    type: Object as PropType<IOnBoardLine>,
  },
},
  emits: ["onSlideChange", "onClickLineInfo", "onClickBusStopLocation", "updateBusLocation", "onChangedCheck", "onClickScheduleBtn", "onClickReportBtn", "onClickBusImage"],
  setup(__props, { expose: __expose, emit: __emit }) {

SwiperCore.use([EffectCoverflow, Navigation, Pagination]);



const emit = __emit;

const swiperOptions = {
  class: "card-swiper",
  modules: [EffectCoverflow],
  effect: "coverflow" as Effect,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 120,
    modifier: 1,
    slideShadows: false,
  },
  centeredSlides: true,
  loop: false,
  slidesPerView: 1.2,
  spaceBetween: 30,
  pagination: {
    el: ".pagination_bullet",
    type: "fraction" as PaginationType,
  },
  paginationClickable: true,
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
  },
  observer: true, // 슬라이드가 동적으로 추가되거나 제거될 때 Swiper 인스턴스 업데이트 여부
  breakpoints: {
    360: {
      spaceBetween: 40,
    },
    428: {
      spaceBetween: 45,
    },
    470: {
      spaceBetween: 60,
    },
  },
};

const mainCard = ref<InstanceType<typeof MainCard>[]>();
const swiperRealIndex = ref(0);
const onSlideChange = (swiper: SwiperCore) => {
  mainCard.value?.[swiper.previousIndex]?.closeTooltip();
  swiperRealIndex.value = swiper.realIndex;
  emit("onSlideChange", swiper.realIndex);
};

const closeTooltip = () => {
  mainCard.value?.[swiperRealIndex.value]?.closeTooltip();
};

__expose({ closeTooltip });

const __returned__ = { emit, swiperOptions, mainCard, swiperRealIndex, onSlideChange, closeTooltip, MainCard, get Swiper() { return Swiper }, get SwiperSlide() { return SwiperSlide } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})